import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/**
 * UI array → API dictionary: { [excelColumn]: targetField }
 * @param {Array<{ sourceKey: string, targetField: string }> | Record<string, string>} fieldMappings
 */
function toFieldMappingsDictionary(fieldMappings) {
  if (
    fieldMappings &&
    typeof fieldMappings === "object" &&
    !Array.isArray(fieldMappings)
  ) {
    return { ...fieldMappings };
  }

  const payload = {};
  (Array.isArray(fieldMappings) ? fieldMappings : []).forEach((item) => {
    const sourceKey = item?.sourceKey;
    const targetField = item?.targetField;
    if (sourceKey && targetField) {
      payload[sourceKey] = targetField;
    }
  });
  return payload;
}

/**
 * Excel lead import (multipart).
 * @param {{
 *   file: File,
 *   mainPlatformId: string,
 *   fieldMappings: Array<{ sourceKey: string, targetField: string }> | Record<string, string>,
 *   parasutAccountId?: string
 * }} form
 */
export const Import = async (form) => {
  const fd = new FormData();
  fd.append("file", form.file);
  fd.append("mainPlatformId", form.mainPlatformId);
  fd.append(
    "fieldMappings",
    JSON.stringify(toFieldMappingsDictionary(form.fieldMappings))
  );
  if (form.parasutAccountId) {
    fd.append("parasutAccountId", form.parasutAccountId);
  }
  const response = await $api.post(Endpoints.LeadImport.Import(), fd);
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ query?: { page?: number, limit?: number } }} [option]
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.LeadImport.GetAll(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { importId: string }, query?: { page?: number, limit?: number } }} option
 */
export const GetRows = async (option) => {
  const response = await $api.get(Endpoints.LeadImport.GetRows(option));
  return ResponseChecker(defaultMessages, response);
};

export default {
  Import,
  GetAll,
  GetRows,
};
